import React, { Component } from 'react';
import ProductCard from '../component/ProductCard';
import ProductListSearch from '../component/ProductListSearch';
import ProductListCollection from '../component/ProductListCollection';
import { Grid, Row, Col } from 'react-bootstrap';
import FirebaseService from '../service/FirebaseService';
import { withRouter } from "react-router-dom";
import ReactDOM from 'react-dom';
import base from '../rebase';

var _ = require('lodash');
var ReactGA = require('react-ga');

const brStyle = {
    minHeight: '800px'
};

var products = [
    {
        name: "hKosangas",
        brand: "Katsura",
        code: " KT92 50kg~400kg/hr (Zone 1)",
        description: "Kosangas Indirect electrically heated water bath vaporizers",
        category: "vaporizers",
        image: "vaporizer_edit.jpg"
    },
    {
        name: "aPentax Self Priming Water Pumps",
        brand: "Pentax",
        code: "INOX Series",
        description: "Kosangas Indirect electrically heated water bath vaporizers",
        category: "water pump",
        image: "regulator2_edit.jpg"
    },
    {
        name: "zSelf Priming Water Pumps",
        brand: "Itokoki",
        code: "CAB Series",
        description: "Kosangas Indirect electrically heated water bath vaporizers",
        category: "water pump",
        image: "gas_compressor_edit.jpg"
    }
]

var categories = [
    {
        id: "vaporizer",
        name: "vaporizer",
        brands: [
            {
                id: "Kosangas",
                name: "Kosangas"
            }
        ]
    },
    {
        id: "Burner-Controls",
        name: "Burner Controls",
        brands: [
            {
                id: "Black-Teknigas",
                name: "Black Teknigas"
            }
        ]
    },
    {
        id: "Regulator",
        name: "Regulator",
        brands: [
            {
                id: "Sensus",
                name: "Sensus"
            },
            {
                id: "ECII/Rego",
                name: "ECII/Rego"
            },
            {
                id: "Jeavons-(Elster)",
                name: "Jeavons (Elster)"
            },
            {
                id: "Itokoki",
                name: "Itokoki"
            },
            {
                id: "Katsura",
                name: "Katsura"
            },
            {
                id: "Fujikoki",
                name: "Fujikoki"
            },
            {
                id: "Econex",
                name: "Econex"
            }
        ]
    },
    {
        id: "Gas-Flow-Meter",
        name: "Gas Flow Meter",
        brands: [
            {
                id: "Sensus",
                name: "Sensus"
            }
        ]
    },
    {
        id: "Water-Heater",
        name: "Water Heater",
        brands: [
            {
                id: "Bradford-White",
                name: "Bradford-White"
            },
            {
                id: "Bock",
                name: "Bock"
            }
        ]
    },
    {
        id: "Gas-Compressor",
        name: "Gas Compressor",
        brands: [
            {
                id: "Corken",
                name: "Corken"
            }
        ]
    },
    {
        id: "Level-Gauge",
        name: "Level Gauge",
        brands: [
            {
                id: "Rochester",
                name: "Rochester"
            }
        ]
    },
    {
        id: "Valve",
        name: "Valve",
        brands: [
            {
                id: "ECII/Rego",
                name: "ECII/Rego"
            },
            {
                id: "Itokoki",
                name: "Itokoki"
            },
            {
                id: "Xylem-(Alcon)",
                name: "Xylem (Alcon)"
            },
            {
                id: "Burkert",
                name: "Burkert"
            }
        ]
    },
    {
        id: "Rubber-Hose",
        name: "Rubber Hose",
        brands: [
            {
                id: "Itokoki",
                name: "Itokoki"
            },
            {
                id: "Katsura",
                name: "Katsura"
            }
        ]
    },
    {
        id: "Automatic-Change-Over",
        name: "Automatic Change Over",
        brands: [
            {
                id: "Itokoki",
                name: "Itokoki"
            },
            {
                id: "Katsura",
                name: "Katsura"
            }
        ]
    },
    {
        id: "Gas-Detector",
        name: "Gas Detector",
        brands: [
            {
                id: "Lable",
                name: "Lable"
            }
        ]
    },
    {
        id: "Water-Pump",
        name: "Water Pump",
        brands: [
            {
                id: "Pentax",
                name: "Pentax"
            }
        ]
    },
    {
        id: "Magnetic-Chemical-Pump",
        name: "Magnetic Chemical Pump",
        brands: [
            {
                id: "Xylem-(Totton)",
                name: "Xylem (Totton)"
            }
        ]
    },
    {
        id: "Ball-Valve",
        name: "Ball Valve",
        brands: [
            {
                id: "R.U.B",
                name: "R.U.B"
            },
            {
                id: "Kitz",
                name: "Kitz"
            }
        ]
    },
    {
        id: "MISCELLANEOUS",
        name: "MISCELLANEOUS",
        brands: [
            {
                id: "Kusaba",
                name: "Kusaba"
            }
        ]
    },
    {
        id: "Governor",
        name: "Governor",
        brands: [
            {
                id: "Giuliani-Anello",
                name: "Giuliani Anello"
            },
            {
                id: "Maxitrol",
                name: "Maxitrol"
            }
        ]
    }
];

var brands = [
    {
        id: "Pentax",
        name: "Pentax"
    },
    {
        id: "Itokoki",
        name: "Itokoki"
    },
    {
        id: "Katsura",
        name: "Katsura"
    }
]

const sortOptions = ["namea", "namez", "branda", "brandz"];


export default class ProductList extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            currentGroup: 'all',
            sortedBy: 'namea',
            searchBy: '',
            products: [],
            filteredProducts: [],
            displayedProducts: [],
            productImages: [],
            searchBrand: '',
            searchCaterory: '',
            categoriesA: [],
            brandsA: [],
            categoriesB: []
        }

        this.handleGroupFiltering = this.handleGroupFiltering.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.performGroupFilter = this.performGroupFilter.bind(this);
    }
    init(){ //https://github.com/tylermcginnis/re-base/issues/176
        this.categoriesRef =  base.bindToState('categories', {
            context: this,
            state: 'categoriesA',
            asArray: true
        });

        this.brandsRef =  base.bindToState('brands', {
            context: this,
            state: 'brandsA',
            asArray: true
        });

        // console.log("componentDidMount");
        // console.log(this.getCategories());
    }

    // this should take in a brand id and return the info about the brand and add to the state maybe...
    // just like how we merge the iamges with the product
    getCategories = () => {
        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
        return this.state.brandsA.filter(brand => {
            // console.log(brand);
            // _.map(category.brands , brand => {
            //         return this.state.brandsA.includes(brand);
            //     }
            // );
            // return this.state.brandsA;
            if(this.state.categoriesA.brands){//this would work if category was a single entry but we get a whole array of category to deal with
              return this.state.categoriesA.brands.includes(brand.ids);
            }
        })
      }

    componentDidMount() {

        var productsArrayFromDb = FirebaseService.readProductFromDatabase(productCallback => {
            // console.log("componentDidMount", productCallback)

            var product1 = [];
            _.map(productCallback, p => product1.push(p));
            // console.log("componentDidMount 1", product1)

            this.setState({
                products: _.toArray(product1),
                filteredProducts: product1,
                displayedProducts: product1
            }, function () {
                if (this.props.match.params.brand && this.props.match.params.category && this.state.searchBrand == '' && this.state.searchCaterory == '') {
                    this.performGroupFilter(this.props.match.params.category, this.props.match.params.brand);
                }
            });
        });

        var productImagesArrayFromDb = FirebaseService.getProductImagesFromDatabase(productImageCallback => {
            // console.log("componentDidMount", productImageCallback)

            var productImages1 = [];
            _.map(productImageCallback, p => productImages1.push(p));
            // console.log("componentDidMount 1", product1)

            this.setState({
                productImages: _.toArray(productImages1)
            });
            // console.log("componentDidMount productImages", productImages);

        });

        this.init();

    }

    handleGroupFiltering(category, brand) {
        ReactGA.event({
            category: 'Product List Page',
            action: 'Filtered Category',
            label: category + "-" + brand
        });

        this.setState({
            searchBrand: brand,
            searchCaterory: category
        }, function () {
            this.performGroupFilter(category, brand);
            this.props.history.push("/products/" + category + "/" + brand);
        }.bind(this));
    }

    performGroupFilter(category, brand) {
        var productClone = this.state.products;
        // console.log("performGroupFilter brand = " + brand);
        // console.log("performGroupFilter category = " + category);

        if (category != "all") {
            productClone = productClone.filter(function (product) {
                return _.toLower(product.category).split(' ').join('-') === _.toLower(category);
            });
        }

        if (brand != "all") {
            productClone = productClone.filter(function (product) {
                return _.toLower(product.brand).split('/').join('-').split(' ').join('-') === _.toLower(brand);
            });
        }

        productClone = this.sort(this.state.sortedBy, productClone);

        this.setState({
            currentGroup: category,
            filteredProducts: productClone,
            displayedProducts: productClone,
            searchBrand: brand,
            searchCaterory: category
        })
    }

    handleSearch(text) {
        var keyword = _.toLower(text);

        if (_.size(keyword) > 0) {
            var productClone = this.state.filteredProducts.filter(function (product) {
                return _.toLower(product.name).indexOf(keyword) > -1
            });

            this.setState({
                // searchBy: keyword,
                displayedProducts: productClone
            })
        } else {
            this.setState({
                // searchBy: keyword,
                displayedProducts: this.state.filteredProducts
            })
        }
    }

    handleSort(sortOption) {
        if (!_.some(sortOptions, (el) =>
            _.includes(sortOption, el))) {
            sortOption = "namea"
        }

        var productClone = this.sort(sortOption, this.state.filteredProducts);

        this.setState({
            sortedBy: sortOption,
            displayedProducts: productClone
        })
    }

    sort(sortOption, productClone) {

        var clone;
        switch (sortOption) {
            case "namea":
                clone = _.sortBy(productClone, 'name');
                break;
            case "namez":
                clone = _.sortBy(productClone, 'name').reverse();
                break;
            case "branda":
                clone = _.sortBy(productClone, 'brand');
                break;
            case "brandz":
                clone = _.sortBy(productClone, 'brand').reverse();
                break;
            default:
                this.setState({
                    sortedBy: "namea"
                })
                clone = _.sortBy(productClone, ['name']);
                break;
        }
        return clone;
    }

    render() {
        var productCardArea = '';
        var productCards = this.state.displayedProducts.map(product => <ProductCard key={product.code} products={product} productImages={this.state.productImages} getTranslatedText={this.props.getTranslatedText}/>);
        // if search or filter contains nothing, then show something

        if (_.size(this.state.products) < 1) {
            productCards = <Col lg={6}><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i><span className=""> {this.props.getTranslatedText("Loading")}</span></Col>
        } else if (_.size(productCards) < 1) {
            productCards = <Col lg={6}>{this.props.getTranslatedText("NoProductToBeDisplayed")}</Col>
        }

        // Only show the Category list on the left when it got data back from DB
        var productListCollectionArea = '';
        if(Array.isArray(this.state.categoriesA) && Array.isArray(this.state.brandsA) && 
            (_.size(this.state.brandsA) > 0) && (_.size(this.state.categoriesA) > 0)) {
            productListCollectionArea = <ProductListCollection handleGroupFiltering={this.handleGroupFiltering} categories={this.state.categoriesA} brands={this.state.brandsA} currentGroup={this.state.currentGroup} getTranslatedText={this.props.getTranslatedText} language={this.props.language}/>
        }

        productCardArea = (
            <div>
                <ProductListSearch handleSearch={this.handleSearch} handleSort={this.handleSort} categories={this.state.categoriesA} brands={this.state.brandsA} sortedBy={this.state.sortedBy} searchedBy={this.state.searchBy} getTranslatedText={this.props.getTranslatedText} />
                <hr className="my-4" />
                <Row className="show-grid">
                    {productCards}
                </Row>
            </div>
        );
        


        return (
            <Grid className="py-4" style={brStyle}>
                <Row>
                    <Col lg={9} className="push-lg-3">
                        {productCardArea}
                    </Col>
                    <Col lg={3} className="pull-lg-9">
                        {productListCollectionArea}
                    </Col>
                </Row>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/ProductList.js